module.exports = __webpack_public_path__ + "static/Stocksy_woman-edc319d0baec9fd21d5b2802dfad9a01.jpg";